<td style="width: 5%" class="value-cell">{{index}}</td>
<td style="width: 7%" class="value-cell" title="{{event.Id}}">{{event.Id}}</td>
<td style="width: 18%" class="value-cell" title="{{event.eventTypeStr}}">{{event.eventTypeStr}}</td>
<td *ngIf="showParentType" style="width: 10%" class="value-cell" title="{{event.parentTypeStr}}">{{event.parentTypeStr}}
</td>
<td [style.width]="showParentType ? '17%' : '27%'" class="value-cell" title="{{userName}}">{{userName}}</td>
<td style="width: 10%" class="value-cell" title="{{event.createdAtStr}}">{{event.createdAtStr}}</td>
<td [style.width]="showParentType ? '18%' : '28%'" class="value-cell wrap-text-cell" title="{{details}}">
    {{details}}</td>
<td style="width: 5%" class="value-cell">
    <button *ngIf="details" mat-icon-button (click)="copyMetadata()" matTooltip="Copy metadata to clipboard">
        <mat-icon>content_copy</mat-icon>
    </button>
</td>